// The app's language codes are not `Intl` locales, and this is the one place
// that knows the difference.
//
// `i18n.language` is `en` / `si` / `ta` — the names of the translation bundles.
// `Intl` wants a BCP-47 locale, and the bare language subtags are not the same
// thing: `en` formats dates as `3/15/2026` (US order) where every clinic using
// this app reads `15/03/2026`. So the map exists, and the answer for `en` is
// `en-GB`.
//
// It lives here rather than beside a formatter because it was already in three
// places — a date formatter, a number formatter, and the home page's greeting —
// and only one of them had it. Dates went through a map, numbers were handed the
// raw language code, and both sat on the same screen. Neither is visibly wrong
// today, because `si` and `ta` happen to need no correction and integers format
// the same either way; the failure is the next locale added, which would get
// fixed in whichever copy the author happened to open.

const LOCALE_BY_LANG: Record<string, string> = { en: 'en-GB', si: 'si-LK', ta: 'ta-LK' };

/**
 * The `Intl` locale for an app language, or `undefined` for one this build has
 * no mapping for.
 *
 * `undefined` rather than a guess: it is what every `Intl` constructor takes to
 * mean "use the runtime's own default", which is a better answer for an unknown
 * language than a locale picked by string manipulation.
 */
export function localeFor(lang: string): string | undefined {
  return LOCALE_BY_LANG[lang] ?? undefined;
}
